import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SCUIButton } from '../../../../atomic/atoms';
import { FormControl, Grid, InputLabel, MenuItem, Select, Checkbox, FormControlLabel } from '@mui/material';

import { getTenants } from '../../../RuleService/helper/RuleModal.mapper';
import { useRuleService } from '../../context/RuleServiceContext';

import { ruleServicePng } from '../../../../assets/images';
import { TS } from './tenantSelect.classes';

export const TenantSelect: FC = () => {
    const [selectedTenant, setSelectedTenant] = useState<string>('');
    const tenants = getTenants();

    const { tenant, setTenant, displayGlobalRules, setDisplayGlobalRules } = useRuleService();

    const { t } = useTranslation();

    useEffect(() => {
        setSelectedTenant(tenant || '');
    }, [tenant]);

    return (
        <div className={TS.root}>
            <Grid
                className={TS.imageRow}
                style={{ display: 'flex', justifyContent: 'center' }}
                size={{
                    xl: 12,
                    md: 12,
                    lg: 12,
                    xs: 12,
                }}
            >
                <img className={TS.image} src={ruleServicePng} alt="tenant" />
            </Grid>
            <Grid
                className={TS.formRow}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
                size={{
                    xl: 12,
                    md: 12,
                    lg: 12,
                    xs: 12,
                }}
            >
                <FormControl className={TS.domainControl} style={{ width: 450, margin: '20px' }}>
                    <InputLabel className={TS.domainLabel} id="labelApp">
                        {'Domain'}
                    </InputLabel>
                    <Select
                        label={'Domain'}
                        labelId="labelApp"
                        id="parentMenuLabel"
                        className={TS.domainSelect}
                        value={selectedTenant}
                        onChange={(e: any) => setSelectedTenant(e.target.value)}
                        fullWidth
                    >
                        {(tenants || []).map((item: any, index: number) => (
                            <MenuItem
                                className={TS.domainOption}
                                key={index}
                                id={item.label}
                                value={item.value}
                                data-tenant={item.value}
                            >
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControlLabel
                    className={TS.globalRuleControl}
                    sx={{
                        margin: '0px 20px 20px 20px',
                        '& .MuiCheckbox-root': {
                            padding: '0',
                            marginRight: '8px',
                        },
                    }}
                    control={
                        <Checkbox
                            id="parentGlobalLabel"
                            className={TS.globalRuleCheckbox}
                            checked={displayGlobalRules}
                            onChange={(e: any) => setDisplayGlobalRules(e.target.checked)}
                        />
                    }
                    label={`${t('ruleManagement.globalRule')}`}
                />
            </Grid>
            <Grid
                className={TS.actionsRow}
                style={{ display: 'flex', justifyContent: 'center' }}
                size={{
                    xl: 12,
                    md: 12,
                    lg: 12,
                    xs: 12,
                }}
            >
                <SCUIButton
                    className={TS.searchButton}
                    text={t('general.search')}
                    type="primary"
                    sizeType="fixed"
                    size={'l'}
                    onClick={() => {
                        setTenant(selectedTenant);
                    }}
                    style={{ width: '150px' }}
                />
            </Grid>
        </div>
    );
};
